import { AvatarMenu } from '@containers/Header/AvatarMenu'
import React from 'react'
import styled, { useTheme } from 'styled-components'

interface PreAuthCardLayoutProps {
  children: React.ReactNode
  footer?: React.ReactNode
  /** Signed out visitors have no account to act on, so the menu can be hidden. */
  showUserMenu?: boolean
}

export const PreAuthCardLayout: React.FC<PreAuthCardLayoutProps> = ({
  children,
  footer,
  showUserMenu = true
}) => {
  const theme = useTheme()

  return (
    <Page>
      {showUserMenu && (
        <UserMenuAnchor>
          <AvatarMenu />
        </UserMenuAnchor>
      )}
      <Wordmark src={theme.assets.logo} alt="NoCFO" />
      <Card>{children}</Card>
      {footer}
    </Page>
  )
}

const Page = styled.div`
  position: relative;
  min-height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing.xxl}rem;
  background: ${({ theme }) => theme.colors.neutralGray};
  padding: ${({ theme }) => theme.spacing.xxl}rem ${({ theme }) => theme.spacing.lg}rem;
  box-sizing: border-box;
`

const UserMenuAnchor = styled.div`
  position: absolute;
  top: ${({ theme }) => theme.spacing.lg}rem;
  right: ${({ theme }) => theme.spacing.lg}rem;
`

const Wordmark = styled.img`
  height: ${({ theme }) => theme.assets.menuLogo?.height ?? `${theme.iconSize.md}rem`};
  width: auto;
  max-width: ${({ theme }) => theme.assets.menuLogo?.maxWidth ?? '140px'};
  object-fit: contain;
`

const Card = styled.div`
  width: 100%;
  max-width: 460px;
  background: ${({ theme }) => theme.colors.neutralWhite};
  border-radius: ${({ theme }) => theme.borderRadius.md}rem;
  border: 1px solid ${({ theme }) => theme.colors.borderSoft};
  padding: ${({ theme }) => theme.spacing.xl}rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.lg}rem;
`

export const PreAuthCardHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xxs}rem;
`

export const PreAuthCardTitle = styled.h2`
  margin: 0;
  font-size: ${({ theme }) => theme.fontSize.xl}rem;
  font-weight: 700;
  line-height: 1.2;
  color: ${({ theme }) => theme.colors.neutralBlack};
`

export const PreAuthCardDescription = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colors.iconGray};
  font-size: ${({ theme }) => theme.fontSize.sm}rem;
  line-height: 1.5;
`

export const PreAuthCardButtonRow = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.md}rem;
  align-items: center;
  justify-content: space-between;
  padding-top: ${({ theme }) => theme.spacing.md}rem;
`
